import { render } from "./Currencies.vue?vue&type=template&id=4dc9ab68&ts=true"
import script from "./Currencies.vue?vue&type=script&lang=ts"
export * from "./Currencies.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__